import { ensureTrailingFullStop } from 'lib/string/stringUtils'

export function appendTranscript(message: string, transcript: string): string {
  const trimmedTranscript = transcript.trim()
  return message.trim() ? `${message} ${trimmedTranscript}` : trimmedTranscript
}

/** Adds a whole sentence after the customer's own draft, ending the draft's sentence first if it's still open. */
export function appendSentence(message: string, sentence: string): string {
  // A trailing comma, semicolon or colon, Arabic ones included, gives way to the full stop.
  return appendTranscript(ensureTrailingFullStop(message.replace(/[\s,;:،؛]+$/, '')), sentence)
}
